import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { getContestSummariesByCommissionerId } from "~/services/contests/contests.service.api";
import { STALE_TIME } from "~/domains/contest/constants/query";

function useChannelSummary(userId: string) {
  const { data, isLoading, error } = useQuery({
    queryKey: ['channel-summary', userId],
    queryFn: () => getContestSummariesByCommissionerId(userId),
    staleTime: STALE_TIME,
  });

  const totalContests = useMemo(
    () => data?.reduce((acc, curr) => acc + curr.contestsCount, 0
  ), [data]);

  return {
    data,
    totalContests,
    isLoading,
    error,
  };
}

export default useChannelSummary;

